import { render, staticRenderFns } from "./prepositioner-blandade-ovningar.vue?vue&type=template&id=6777f933&scoped=true"
import script from "./prepositioner-blandade-ovningar.vue?vue&type=script&lang=js"
export * from "./prepositioner-blandade-ovningar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6777f933",
  null
  
)

export default component.exports